import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import ContactForm from './ContactForm';

function Result(props) {
  return (
    <CSSTransitionGroup
      className="container result"
      component="div"
      transitionName="fade"
      transitionEnterTimeout={800}
      transitionLeaveTimeout={500}
      transitionAppear
      transitionAppearTimeout={500}
    >
      <div>
        <p>
          Tienes predilección para estudiar ¡<strong>{props.quizResult}</strong>!.
        </p>
        <p class="justify">
          <i>{props.quizDesc}</i>
        </p>
        <p>
           En UNISANT queremos apoyarte, completa el formulario y obtén una <b>beca de hasta un 60% de descuento</b> en tu carrera profesional.
        </p>

        <ContactForm interes={props.quizResult} desc={props.quizDesc} mode={props.mode} panfleto={props.panfleto}/>

      </div>
    </CSSTransitionGroup>
  );
}

Result.propTypes = {
  quizResult: PropTypes.string.isRequired,
  quizDesc: PropTypes.string.isRequired,
  mode : PropTypes.number,
  panfleto: PropTypes.number
};

export default Result;
